import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overlay-modal"
}
const _hoisted_2 = { class: "modal-vincular" }
const _hoisted_3 = { class: "modal-sub" }
const _hoisted_4 = { class: "nota" }
const _hoisted_5 = {
  key: 0,
  class: "ruta-contexto"
}
const _hoisted_6 = { class: "ruta-etiqueta" }
const _hoisted_7 = { class: "ruta-nombre" }
const _hoisted_8 = {
  key: 0,
  class: "ruta-nodo ruta-indicador"
}
const _hoisted_9 = { class: "ruta-nombre" }
const _hoisted_10 = {
  key: 1,
  class: "info"
}
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 0,
  class: "ayuda"
}
const _hoisted_16 = {
  key: 1,
  class: "ayuda"
}
const _hoisted_17 = {
  key: 0,
  class: "seccion"
}
const _hoisted_18 = { class: "seccion-head" }
const _hoisted_19 = { class: "contador" }
const _hoisted_20 = { class: "lista-preguntas" }
const _hoisted_21 = { class: "pq-fija" }
const _hoisted_22 = {
  key: 0,
  class: "pq-grupo"
}
const _hoisted_23 = {
  key: 1,
  class: "seccion"
}
const _hoisted_24 = { class: "seccion-head" }
const _hoisted_25 = { class: "contador" }
const _hoisted_26 = { class: "lista-preguntas" }
const _hoisted_27 = {
  key: 0,
  class: "separador-asignadas"
}
const _hoisted_28 = { class: "item-pregunta" }
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "pq-texto" }
const _hoisted_31 = {
  key: 0,
  class: "pq-grupo"
}
const _hoisted_32 = {
  key: 1,
  class: "pq-aviso"
}
const _hoisted_33 = {
  key: 0,
  class: "aviso-robo"
}
const _hoisted_34 = {
  key: 2,
  class: "info"
}
const _hoisted_35 = {
  key: 3,
  class: "error"
}
const _hoisted_36 = { class: "botones" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = ["disabled"]

import { ref, computed, watch } from 'vue'
import type { FormularioDisponible, PreguntaDeFormulario } from '@/services/IndicadorFormularioService'
import {
  getFormulariosDisponiblesService,
  vincularFormularioService
} from '@/services/IndicadorFormularioService'

interface NodoRuta { etiqueta: string; nombre: string }


export default /*@__PURE__*/_defineComponent({
  __name: 'VincularFormularioModal',
  props: {
    visible: { type: Boolean },
    idIndicador: {},
    nombreIndicador: {},
    ruta: {}
  },
  emits: ["cerrar", "vinculado"],
  setup(__props: any, { emit: __emit }) {

/**
 * Vinculación de un formulario existente a un indicador.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props

const emit = __emit

const formularios = ref<FormularioDisponible[]>([])
const idInstrumento = ref<number | null>(null)
const seleccionadas = ref<number[]>([])
const tipoFiltro = ref('')
const cargando = ref(false)
const guardando = ref(false)
const error = ref('')

const formularioActual = computed(() =>
  formularios.value.find(x => x.id_instrumento === idInstrumento.value)
)

const preguntasDelFormulario = computed<PreguntaDeFormulario[]>(
  () => formularioActual.value?.preguntas ?? []
)

const preguntasOrdenadas = computed<PreguntaDeFormulario[]>(() => {
  return [...preguntasDelFormulario.value].sort((a, b) => {
    const aAsignada = a.id_indicador != null ? 1 : 0
    const bAsignada = b.id_indicador != null ? 1 : 0
    return aAsignada - bAsignada
  })
})

/**
 * El formulario entero evalúa este indicador: no se eligen preguntas y la
 * nota es una sola para todo.
 */
const esFormularioCompleto = computed(
  () => formularioActual.value?.modalidad === 'formulario_completo'
)

/** Tipos presentes en los formularios, deduplicados por etiqueta visible. */
const tiposDisponibles = computed(() => {
  const vistos = new Set<string>()
  const result: { valor: string; etiqueta: string }[] = []
  for (const f of formularios.value) {
    const etiqueta = (f.tipo_etiqueta || f.tipo || '').trim()
    if (!etiqueta || vistos.has(etiqueta)) continue
    vistos.add(etiqueta)
    result.push({ valor: etiqueta, etiqueta })
  }
  return result
})

const formulariosFiltrados = computed(() =>
  tipoFiltro.value
    ? formularios.value.filter(f => (f.tipo_etiqueta || f.tipo || '').trim() === tipoFiltro.value)
    : formularios.value
)

function esDeOtroIndicador(p: PreguntaDeFormulario): boolean {
  return p.id_indicador != null && p.id_indicador !== props.idIndicador
}

const hayRobadas = computed(() =>
  preguntasDelFormulario.value.some(p => seleccionadas.value.includes(p.id_pregunta) && esDeOtroIndicador(p))
)

watch(
  () => [props.visible, props.idIndicador] as const,
  async ([visible]) => {
    if (!visible || !props.idIndicador) return
    cargando.value = true
    error.value = ''
    idInstrumento.value = null
    seleccionadas.value = []
    tipoFiltro.value = ''
    try {
      formularios.value = await getFormulariosDisponiblesService(props.idIndicador)
    } finally {
      cargando.value = false
    }
  },
  { immediate: true }
)

/** Al elegir formulario se premarcan las preguntas que ya son de este indicador. */
function alCambiarFormulario() {
  seleccionadas.value = esFormularioCompleto.value
    ? []
    : preguntasDelFormulario.value
      .filter(p => p.id_indicador === props.idIndicador)
      .map(p => p.id_pregunta)
}

async function guardar() {
  if (!props.idIndicador || !idInstrumento.value) return
  guardando.value = true
  error.value = ''
  try {
    // En formulario completo no se mandan preguntas: va entero al indicador.
    const res = await vincularFormularioService(
      props.idIndicador,
      idInstrumento.value,
      esFormularioCompleto.value ? undefined : seleccionadas.value
    )
    if (!res.ok) {
      error.value = res.error ?? 'No se pudo vincular.'
      return
    }
    emit('vinculado', res.mensaje ?? 'Formulario vinculado.')
    emit('cerrar')
  } finally {
    guardando.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[14] || (_cache[14] = _createElementVNode("h4", { class: "modal-titulo" }, "Vincular formulario", -1)),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.nombreIndicador || `Indicador #${_ctx.idIndicador}`), 1),
          _createElementVNode("p", _hoisted_4, [
            (esFormularioCompleto.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" Este formulario califica como una sola unidad: va completo a este indicador, sin repartir preguntas, y se califica con una sola nota. ")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" El formulario de opinión es compartido: se crea una vez y cada indicador toma de él las preguntas que le corresponden. La nota del indicador será el promedio de las preguntas que marques. ")
                ], 64))
          ]),
          (_ctx.ruta?.length || _ctx.nombreIndicador)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruta, (nodo, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "ruta-nodo"
                  }, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(nodo.etiqueta), 1),
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ruta-sep" }, "·", -1)),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(nodo.nombre), 1)
                  ]))
                }), 128)),
                (_ctx.nombreIndicador)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "ruta-etiqueta" }, "Indicador", -1)),
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "ruta-sep" }, "·", -1)),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.nombreIndicador), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (cargando.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Cargando formularios…"))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { for: "tipo-sel" }, "Tipo de instrumento", -1)),
                  _withDirectives(_createElementVNode("select", {
                    id: "tipo-sel",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tipoFiltro).value = $event))
                  }, [
                    _cache[7] || (_cache[7] = _createElementVNode("option", { value: "" }, "Todos los tipos", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiposDisponibles.value, (t) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: t.valor,
                        value: t.valor
                      }, _toDisplayString(t.etiqueta), 9, _hoisted_12))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, tipoFiltro.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { for: "form-sel" }, "Formulario", -1)),
                  _withDirectives(_createElementVNode("select", {
                    id: "form-sel",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((idInstrumento).value = $event)),
                    onChange: alCambiarFormulario
                  }, [
                    _cache[9] || (_cache[9] = _createElementVNode("option", {
                      value: null,
                      disabled: ""
                    }, "Seleccione un formulario", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formulariosFiltrados.value, (f) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: f.id_instrumento,
                        value: f.id_instrumento
                      }, _toDisplayString(f.nombre) + " · " + _toDisplayString(f.tipo_etiqueta || f.tipo) + " (" + _toDisplayString(f.preguntas.length) + " pregunta(s)) ", 9, _hoisted_14))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, idInstrumento.value]
                  ]),
                  (!formularios.value.length)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_15, " No hay formularios con preguntas todavía. Créalo primero desde Instrumentos. "))
                    : (!formulariosFiltrados.value.length)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_16, " Ningún formulario de ese tipo. Cambia el filtro para ver los demás. "))
                      : _createCommentVNode("", true)
                ]),
                (esFormularioCompleto.value && idInstrumento.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _cache[11] || (_cache[11] = _createElementVNode("h5", null, "Preguntas del formulario", -1)),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(preguntasDelFormulario.value.length) + " en total", 1)
                      ]),
                      _createElementVNode("ul", _hoisted_20, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preguntasOrdenadas.value, (p) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: p.id_pregunta,
                            class: "item-pregunta"
                          }, [
                            _createElementVNode("span", _hoisted_21, [
                              _createTextVNode(_toDisplayString(p.enunciado) + " ", 1),
                              (p.grupo_interes?.nombre)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(p.grupo_interes.nombre), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : (preguntasDelFormulario.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _cache[12] || (_cache[12] = _createElementVNode("h5", null, "Preguntas de este indicador", -1)),
                          _createElementVNode("span", _hoisted_25, _toDisplayString(seleccionadas.value.length) + " marcada(s)", 1)
                        ]),
                        _createElementVNode("ul", _hoisted_26, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preguntasOrdenadas.value, (p, idx) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: p.id_pregunta
                            }, [
                              (idx > 0 && p.id_indicador != null && preguntasOrdenadas.value[idx - 1].id_indicador == null)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_27, _cache[13] || (_cache[13] = [
                                    _createElementVNode("span", null, "Ya asignadas", -1)
                                  ])))
                                : _createCommentVNode("", true),
                              _createElementVNode("li", _hoisted_28, [
                                _createElementVNode("label", {
                                  class: _normalizeClass({ 'de-otro': esDeOtroIndicador(p) })
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    value: p.id_pregunta,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((seleccionadas).value = $event))
                                  }, null, 8, _hoisted_29), [
                                    [_vModelCheckbox, seleccionadas.value]
                                  ]),
                                  _createElementVNode("span", _hoisted_30, _toDisplayString(p.enunciado), 1),
                                  (p.grupo_interes?.nombre)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(p.grupo_interes.nombre), 1))
                                    : _createCommentVNode("", true),
                                  (esDeOtroIndicador(p))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, " ya es de: " + _toDisplayString(p.indicador?.enunciado), 1))
                                    : _createCommentVNode("", true)
                                ], 2)
                              ])
                            ], 64))
                          }), 128))
                        ]),
                        (hayRobadas.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_33, " Marcaste preguntas que hoy pertenecen a otro indicador. Si guardas, pasarán a este. "))
                          : _createCommentVNode("", true)
                      ]))
                    : (idInstrumento.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_34, "Ese formulario no tiene preguntas."))
                      : _createCommentVNode("", true),
                (error.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(error.value), 1))
                  : _createCommentVNode("", true)
              ], 64)),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("button", {
              class: "btn salir",
              disabled: guardando.value,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('cerrar')))
            }, "Cancelar", 8, _hoisted_37),
            _createElementVNode("button", {
              class: "btn guardar",
              disabled: guardando.value || !idInstrumento.value,
              onClick: guardar
            }, _toDisplayString(guardando.value ? 'Guardando…' : 'Vincular'), 9, _hoisted_38)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})